const brand = {
  name: "BOOKUS",
  desc: "Bookus broneerimissüsteem",
  prefix: "bookus",
  footerText: "Pintek OÜ 2021",
  logoText: "Bookus.live",
  projectName: "Bookus",
  url: "bookus.live",
  img: process.env.ASSETS_URL + "logo.svg",
  notifMsg: "Donec sit amet nulla sed arcu pulvinar ultricies commodo id ligula.",
};

export default brand;
